"use client"

import Image from "next/image"
import Link from "next/link"
import { usePathname } from "next/navigation"

export default function Footer() {
  const currentYear = new Date().getFullYear()
  // /process is the clinic-facing walkthrough; the owner home page doesn't link to it.
  const pathname = usePathname()
  const showProcess = pathname !== "/"

  return (
    <footer className="bg-gray-900 text-white py-[50px] xl:py-[40px] md:py-[30px] sm:py-[40px]">
      <div className="container">
        <div className="flex sm:flex-col flex-row justify-between sm:iitems-center tems-start gap-6 md:gap-2 mb-[50px] sm:gap-[40px] xl:mb-[40px] md:mb-[30px]">
          <div className="flex sm:flex-col items-center flex-row gap-[30px] xl:gap-[20px] md:gap-[12px] sm:gap-[20px]">
            {showProcess && (
              <Link href="/process" className="text-[18px] xl:text-[16px] md:text-[15px] sm:text-[16px] font-samibold hover:text-blue-300">
                The Process
              </Link>
            )}
            <Link href="/about" className="text-[18px] xl:text-[16px] md:text-[15px] sm:text-[16px] font-samibold text-white hover:text-blue-300">
              About
            </Link>
            <Link href="/locations/rangiora" className="text-[18px] xl:text-[16px] md:text-[15px] sm:text-[16px] font-samibold text-white hover:text-blue-300">
              Rangiora
            </Link>
            <Link href="/locations/christchurch" className="text-[18px] xl:text-[16px] md:text-[15px] sm:text-[16px] font-samibold text-white hover:text-blue-300">
              Christchurch
            </Link>
            <Link href="/contact" className="bg-[#0055a4] text-white px-[30px] py-[15px] md:px-[20px] sm:px-[22px] md:py-[10px] sm:py-[15px] md:text-[15px] sm:text-[16px] rounded-full font-medium hover:bg-[#004080] transition-colors text-base">
              Contact us
            </Link>
          </div>
          <div className="flex sm:justify-center justify-end items-center">
            <Image
                src="/icons/logo-rgb-reversed.svg"
                alt="Veterinarian with dog"
                width={329}
                height={49}
                className="w-full h-[49px] xl:h-[40px] w-[329px] md:w-[200px] sm:w-[280px] md:h-[35px] sm:h-[39px]"
            />
        </div>
          
        </div>
        <div className="border-t border-white pt-[30px] flex sm:flex-col flex-row justify-between items-center gap-4 sm:gap-[15px]">
          <div className="flex flex-row sm:gap-4 gap-8">
            <Link href="/terms" className="text-[16px] md:text-[15px] sm:text-[16px] text-white hover:text-gray-400">
              Terms of Use
            </Link>
            <Link href="/privacy" className="text-[16px] md:text-[15px] sm:text-[16px] text-white hover:text-gray-400">
              Privacy Policy
            </Link>
            <Link href="/faq" className="text-[16px] md:text-[15px] sm:text-[16px] text-white hover:text-gray-400">
              FAQ
            </Link>
          </div>

          <div className="flex sm:flex-col flex-row gap-4 items-center">
            <span className="text-[16px] md:text-[15px] sm:text-[16px] text-white">© {currentYear} PetAftercare</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

